// extracted by mini-css-extract-plugin
module.exports = {"contain":"index-module_contain_IkwKk","input-contain":"index-module_input-contain_1DZWs"};